import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'
import { LicenseQuota } from './license-quota.js'
import { LicenseLimitationList } from './license-limitation-list.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('LicenseLimitations')
export class LicenseLimitations {
	// Capabilities
	@jsonProperty(Boolean)
	createProductionBuilds: boolean = false
	@jsonProperty(Boolean)
	runInStandaloneMode: boolean = false
	@jsonProperty(Boolean)
	runInClusterMode: boolean = false
	@jsonProperty(Boolean)
	useMfaSmsTokens: boolean = false
	@jsonProperty(Boolean)
	useMfaAuthenticatorTokens: boolean = false
	@jsonProperty(Boolean)
	useSso: boolean = false
	@jsonProperty(Boolean)
	useExtensions: boolean = false
	@jsonProperty(Boolean)
	makeChanges: boolean = false

	// Quotas
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxNamedUsers: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxLoggedInUsers: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxLoginsPerUser: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxAnonymousUsers: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxAppModules: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxApiWorkers: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxDbs: LicenseQuota = new LicenseQuota(0)
	@jsonProperty(LicenseQuota, {
		serializer: (q: LicenseQuota) => q?.quota,
		deserializer: (quota: number) => new LicenseQuota(quota),
	})
	maxTenants: LicenseQuota = new LicenseQuota(0)

	// Limitations
	@jsonProperty(LicenseLimitationList, {
		serializer: (lll: LicenseLimitationList) => {
			return lll?.allowed
		},
		deserializer: (allowed: string[] | '*') => {
			return new LicenseLimitationList(allowed)
		},
	})
	limitToSpecificInstanceIds: LicenseLimitationList = new LicenseLimitationList(
		[],
	)
	@jsonProperty(LicenseLimitationList, {
		serializer: (lll: LicenseLimitationList) => lll?.allowed,
		deserializer: (allowed: string[] | '*') =>
			new LicenseLimitationList(allowed),
	})
	limitToSpecificAppModules: LicenseLimitationList = new LicenseLimitationList(
		[],
	)
	@jsonProperty(LicenseLimitationList, {
		serializer: (lll: LicenseLimitationList) => lll?.allowed,
		deserializer: (allowed: string[] | '*') =>
			new LicenseLimitationList(allowed),
	})
	limitToSpecificModules: LicenseLimitationList = new LicenseLimitationList([])
	@jsonProperty(LicenseLimitationList, {
		serializer: (lll: LicenseLimitationList) => lll?.allowed,
		deserializer: (allowed: string[] | '*') =>
			new LicenseLimitationList(allowed),
	})
	limitToSpecificDbTypes: LicenseLimitationList = new LicenseLimitationList([])
	@jsonProperty(LicenseLimitationList, {
		serializer: (lll: LicenseLimitationList) => lll?.allowed,
		deserializer: (allowed: string[] | '*') =>
			new LicenseLimitationList(allowed),
	})
	limitToSpecificExtensions: LicenseLimitationList = new LicenseLimitationList(
		[],
	)
	@jsonProperty(LicenseLimitationList, {
		serializer: (lll: LicenseLimitationList) => lll?.allowed,
		deserializer: (allowed: string[] | '*') =>
			new LicenseLimitationList(allowed),
	})
	limitLoginToRoles: LicenseLimitationList = new LicenseLimitationList([])

	constructor(init: LicenseLimitations) {
		assignCommonProperties(this, init)
	}
}
